<small
    class="input-hint"
    [ngClass]="{'input-hint--control-invalid': (control?.touched && control?.invalid) || (control?.dirty && control?.invalid)}"
    a11yFormFieldMessage
>
    <ng-content></ng-content>
</small>
